export const DOCS_DEFAULT_SLUG = 'welcome';

export const docsNavSections = [
    {
        id: 'getting-started',
        title: 'Getting Started',
        items: [
            { slug: 'welcome', label: 'Welcome', icon: 'fa-solid fa-house' },
            { slug: 'what-is-cronpay', label: 'What is CronPay', icon: 'fa-solid fa-circle-info' },
            { slug: 'network', label: 'Arc Network', icon: 'fa-solid fa-globe' },
            { slug: 'quick-start', label: 'Quick Start Guide', icon: 'fa-solid fa-bolt' },
        ],
    },
    {
        id: 'core-features',
        title: 'Core Features',
        items: [
            { slug: 'payment-types', label: 'Payment Types', icon: 'fa-solid fa-credit-card' },
            { slug: 'tracked-payments', label: 'Tracked Payments', icon: 'fa-solid fa-chart-line' },
            { slug: 'payment-requests', label: 'Payment Requests', icon: 'fa-solid fa-inbox' },
        ],
    },
    {
        id: 'dispute-system',
        title: 'Dispute System',
        items: [
            { slug: 'disputes-overview', label: 'Disputes Overview', icon: 'fa-solid fa-flag' },
            { slug: 'resolution-process', label: 'Resolution Process', icon: 'fa-solid fa-scale-balanced' },
        ],
    },
    {
        id: 'jobs-portal',
        title: 'Jobs Portal',
        items: [
            { slug: 'jobs-portal', label: 'Tasks & Escrow', icon: 'fa-solid fa-briefcase' },
            { slug: 'company-workspace', label: 'Company Workspace', icon: 'fa-solid fa-building' },
        ],
    },
    {
        id: 'reference',
        title: 'Reference',
        items: [
            { slug: 'visual-guide', label: 'Diagram guide', icon: 'fa-solid fa-images' },
            { slug: 'trust-and-safety', label: 'Trust & safety', icon: 'fa-solid fa-shield-halved' },
        ],
    },
];

export const allDocSlugs = docsNavSections.flatMap((section) =>
    section.items.map((item) => item.slug),
);

export function findDocNavItem(slug) {
    for (const section of docsNavSections) {
        const item = section.items.find((entry) => entry.slug === slug);
        if (item) {
            return { ...item, sectionTitle: section.title };
        }
    }
    return null;
}
